import { BaseRecord } from "@pankod/refine-core"

export function hashMapFunc(MentionDatas: BaseRecord[], key: string) {

  const dataObj = MentionDatas.reduce((total: BaseRecord, data: BaseRecord) => {

    if (data.id) {
      if (key === 'task-id') total[data?.resourceRelation2?.resourcesid] = data
      if (key === 'user-id') total[data.id] = data
    }
    return total
  }, {})

  return dataObj
}


export function getFileTypeInfo(fileName: any) {
  const extension: any = fileName?.split('.').pop()?.toLowerCase();
  const fileTypes: any = {
    // Viewable in browser    
    viewable: {
      pdf: { mimeType: 'application/pdf', canView: true },
      jpg: { mimeType: 'image/jpeg', canView: true },
      jpeg: { mimeType: 'image/jpeg', canView: true },
      png: { mimeType: 'image/png', canView: true },
      gif: { mimeType: 'image/gif', canView: true },
      svg: { mimeType: 'image/svg+xml', canView: true },
      txt: { mimeType: 'text/plain', canView: true },
      html: { mimeType: 'text/html', canView: true },
      mp4: { mimeType: 'video/mp4', canView: true },
      mp3: { mimeType: 'audio/mp3', canView: true },
      webm: { mimeType: 'video/webm', canView: true },
    },
    // Download only    
    downloadOnly: {
      doc: { mimeType: 'application/msword', canView: false },
      docx: { mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', canView: false },
      xls: { mimeType: 'application/vnd.ms-excel', canView: false },
      xlsx: { mimeType: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', canView: false },
      ppt: { mimeType: 'application/vnd.ms-powerpoint', canView: false },
      pptx: { mimeType: 'application/vnd.openxmlformats-officedocument.presentationml.presentation', canView: false },
      zip: { mimeType: 'application/zip', canView: false },
      rar: { mimeType: 'application/x-rar-compressed', canView: false },
      exe: { mimeType: 'application/x-msdownload', canView: false },
    }
  };
  // Tìm trong viewable trước  
  if (fileTypes.viewable[extension]) {
    return { ...fileTypes.viewable[extension], extension };
  }
  // Tìm trong downloadOnly 
  if (fileTypes.downloadOnly[extension]) {
    return { ...fileTypes.downloadOnly[extension], extension };
  }
  // Unknown file type  
  return { mimeType: 'application/octet-stream', canView: false, extension };
};